export default __webpack_public_path__ + "static/media/nirjala.5dadfb6d.jpg";